// Image Upscaler 图片放大功能翻译

export const imageUpscaler = {
    // Page title and subtitle
    title: 'AI 圖片放大器',
    subtitle: '使用 AI 驅動的放大技術增強您的圖片',
    
    // Upload section
    details: '上傳詳情',
    uploadText: '上傳圖片開始使用',
    uploadFormats: '支援 JPG、PNG、WebP 格式，最大 10MB',
    uploadImageFirst: '請先上傳圖片',
    
    // Settings
    factor: '放大倍數',
    faceEnhancement: '面部增強',
    enhanceTypes: '增強類型',
    
    // Enhancement type options
    denoise: '降噪',
    face_enhance: '面部增強',
    sharpen: '銳化',
    color_enhance: '色彩增強',
    detail_enhance: '細節增強',
    
    // Actions
    enhance: '增強圖片',
    processing: '處理中',
    downloadButton: '下載增強圖片',
    
    // Preview section
    preview: '預覽',
    processingOverlay: '正在處理您的圖片...',
    noImageUploaded: '未上傳圖片',
    resultTitle: '增強結果',
    
    // Features section
    featuresTitle: '強大功能',
    feature1Title: 'AI 驅動增強',
    feature1Desc: '先進的 AI 算法在保持細節的同時增強圖片質量。',
    feature2Title: '多種放大倍數',
    feature2Desc: '選擇 2x、4x 或 8x 放大以滿足您的特定需求。',
    feature3Title: '面部增強',
    feature3Desc: '專門的面部增強技術，適用於人像照片。',
    feature4Title: '高質量輸出',
    feature4Desc: '專業級結果，適用於印刷和數位使用。',
    
    // How to use section
    howToUseTitle: '使用方法',
    step1Title: '上傳圖片',
    step1Desc: '選擇並上傳您的圖片文件（JPG、PNG 或 WebP 格式）。',
    step2Title: '選擇設置',
    step2Desc: '選擇放大倍數，如需要可啟用面部增強。',
    step3Title: '下載結果',
    step3Desc: '處理您的圖片並下載增強版本。',
    
    // FAQ section
    faqTitle: '常見問題',
    faq1: '支援哪些圖片格式？我們支援 JPG、PNG 和 WebP 格式。',
    faq2: '最大文件大小是多少？每張圖片的最大文件大小為 10MB。',
    faq3: '處理需要多長時間？處理通常需要 30-60 秒，取決於圖片大小和設置。',
    
    // Footer
    footerCopyright: '© 2025 Catoo. 保留所有權利。',
    
    // Error messages
    loginExpired: '登錄會話已過期。請重新登錄。',
    imageUpscaleFailed: '圖片放大失敗。請重試。',
    networkError: '網絡錯誤。請檢查您的連接並重試。',
    queryStatusFailed: '查詢處理狀態失敗。',
    processingTimeout: '處理超時。請重試。',
    downloadFailed: '下載失敗。請重試。',
    
    // Success messages
    imageUpscaleComplete: '圖片放大成功完成！'
  };
